/* eslint-disable no-script-url */
/* eslint-disable jsx-a11y/anchor-is-valid */
import TableComponent from "../../components/TableComponent";
import { GridColDef } from "@mui/x-data-grid";
import { useNavigate } from "react-router-dom";

const PaymentsList = () => {
  
  const navigate = useNavigate();

    const rows = [
        {
            id: 1,
            name: "Plumber",
            date: "01 March 2025"
        },
        {
            id: 2,
            name: "Electrician",
            date: "01 March 2025"
        },
        {
            id: 3,
            name: "HVAC",
            date: "01 March 2025"
        },
        {
            id: 4,
            name: "Carpenter",
            date: "01 March 2025"
        },
        {
            id: 5,
            name: "Cleaning",
            date: "01 March 2025"
        },
    ];
    const columns: GridColDef<(typeof rows)[number]>[] = [
        {
            flex: 1,
            minWidth: 180,
            field: "issue",
            headerName: "Issue Detail",
            editable: false,
            sortable: false,
            renderCell: () => {
              return (
                <div className="user_block">
                  <figure className="no_radius">
                    <img src="/static/images/placeholder.png" alt="" />
                  </figure>
                  <p>Sink Leakage</p>
                </div>
              )
            }
        },
        {
            flex: 1,
            minWidth: 220,
            field: "customer",
            headerName: "Customer Detail",
            editable: false,
            sortable: false,
            renderCell: () => {
              return (
                <div className="user_block click_action" onClick={() => navigate('/manage-customers/detail')}>
                  <figure>
                    <img src="/static/images/user_placeholder.png" alt="" />
                  </figure>
                  <p><b>Madelyn Dias</b> <span>madelyndias@gmail.com</span></p>
                </div>
              )
            }
        },
        {
            flex: 1,
            minWidth: 220,
            field: "maintenance",
            headerName: "Maintenance Team Detail",
            editable: false,
            sortable: false,
            renderCell: () => {
              return (
                <div className="user_block click_action" onClick={() => navigate('/manage-maintenance-team/detail')}>
                  <figure className="no_radius">
                    <img src="/static/images/placeholder.png" alt="" />
                  </figure>
                  <p><b>Maintenance Team 1</b> <span>maintenance@gmail.com</span></p>
                </div>
              )
            }
        },
        {
            minWidth: 150,
            field: "offered",
            headerName: "Offered Price",
            editable: false,
            sortable: false,
            align: 'center',
            headerAlign: 'center',
            renderCell: () => {
              return (
                <p className="c_primary"><strong>AED 200</strong></p>
              )
            }
        },
        {
            minWidth: 150,
            field: "commission",
            headerName: "Commission",
            editable: false,
            sortable: false,
            align: 'center',
            headerAlign: 'center',
            renderCell: () => {
              return (
                <p className="c_success"><strong>AED 20</strong></p>
              )
            }
        },
        {
            minWidth: 150,
            field: "total",
            headerName: "Total Amount",
            editable: false,
            sortable: false,
            align: 'center',
            headerAlign: 'center',
            renderCell: () => {
              return (
                <p><strong>AED 220</strong></p>
              )
            }
        },
        {
          minWidth: 240,
          field: "preferred",
          headerName: "Payment Method",
          editable: false,
          sortable: false,
          renderCell: () => {
            return (
              <p><strong>American Express My Zone Card</strong> <br /> <span>xxxx xxxx xxxx 5678</span></p>
            )
          }
        },
        {
            minWidth: 150,
            field: "date",
            headerName: "Date",
            editable: false,
            sortable: false,
        },
        {
            minWidth: 130,
            field: "status",
            headerName: "Status",
            editable: false,
            sortable: false,
            renderCell: () => {
                return (
                    <span className="btn_text c_success">Paid</span>
                )
            }
        }
    ];
    let hidden = ["fullName"];

    return (
        <>
            <div className="sorting_table">
                <TableComponent
                    columns={columns?.filter((item) => !hidden.includes(item.field))}
                    rows={rows}
                />
            </div>
        </>
    );
};

export default PaymentsList;
